<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="form-group wrapper" [formGroup]="form">
  <p-calendar
    [keepInvalid]="true"
    [selectOtherMonths]="true"
    [minDate]="minDate"
    [maxDate]="maxDate"
    [defaultDate]="minDate"
    formControlName="date_fake"
    inputStyleClass="form-control"
    class="prime-ng-datapicker"
    styleClass="d-block"
    monthNavigator="true"
    yearNavigator="true"
    dateFormat="dd.mm.yy"
    [baseZIndex]="1000"
    [yearRange]="yearsRangeFormatted"
    (onSelect)="onSelect()"
    (onBlur)="onType()"
    (onShow)="onCalendarShow()"
    [locale]="en"
    appendTo="body"
    [firstDayOfWeek]="1"
  >
  </p-calendar>
</div>
